export const accountsSelector = (state) => {
    const collection = state.accounts.records.ids.map((id) => {
        return state.accounts.records.byId[id];
    });
    return collection.filter((item) => {
        return item.isVisible === 'yes';
    });
};

export const accountsLoadingSelector = (state) => {
    return state.accounts.records.loading;
};

export const accountSelector = (state, id) => {
    return state.accounts.records.byId[id];
};

export const accountsCountSelector = (state) => {
    return state.accounts.records.totalCount;
};

export const selectedLoginProfileSelector = (state) => {
    let keys = Object.keys(state.accounts.selection);

    if (Array.isArray(keys) && keys.length > 0) {
        return state.accounts.selection[keys[0]];
    }
};

export const accountsSelectionSelector = (state) => {
    return state.accounts.selection;
};

export const accountsSelectionLengthSelector = (state) => {
    let selection = accountsSelectionSelector(state);
    let keys = Object.keys(selection);
    return keys.length;
};
